export const FETCH_USER_INFO = "FETCH_USER_INFO"
export const UPDATE_USER_INFO = "UPDATE_USER_INFO"
export const DELETE_USER_INFO = "DELETE_USER_INFO"